
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["prt-icon prt-option-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 122.16 98.78"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Ebene 2"}},[_c('g',{attrs:{"data-name":"Ebene 1"}},[_c('path',{attrs:{"d":"M114.5 67H97.39v9.07h17.1zm-13.78-15.46h-17.1v9.07h17.1zm-17.1 24.53h8.71V67h-8.71zM79.13 91V38.46l40.2 7.09V91zM18.45 11.14H46.9v9.07H18.45zm35 0h14.3v9.07h-14.3zM9.2 25.11H77V0H9.2zm57.88 53.71H45.69v-9.07h21.39zm0-17.5H52.79v-9.07h14.29zm-20.85 0H17.79v-9.07h28.44zM77 94.87V46.66H9.2v48.21h9.94V66.3h21.38v28.57z","fill":"#b0b2b3"}}),_c('path',{staticClass:"prt-icon-color",attrs:{"d":"M38.64 40.42h28.44v-9.07H38.64zm-20.85 0h14.29v-9.07H17.79zM77 45.16H4.37V26.61H77zM20.56 94.87H39.1V67.71H20.56z"}}),_c('path',{attrs:{"d":"M0 98.78h77v-1.7H0zm79.13-3.91h43v-1.7h-43z","fill":"#868789"}})])])])
          )
        }
      }
    